import AInput from '@/components/A/AInput/AInput'
import styles from './ProfessorLoginPage.module.less'
import APassword from '@/components/A/APassword/APassword'
import AButton from '@/components/A/AButton/AButton'
import { PAGE_LINKS } from '@/router/pageConst'
import { useNavigate } from 'react-router-dom'
import { api } from '@/api'
import { useState } from 'react'
import { message } from 'antd'
import { commonUtils } from '@/helpers/commonUtils'
import { useTranslation } from 'react-i18next'

function ProfessorLoginPage() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const handleLogin = async () => {
    try {
      const { isExpert } = await api.auth.emailLogin({ email, password }).send()
      if (isExpert) {
        navigate(PAGE_LINKS.professorProject)
      } else {
        navigate(PAGE_LINKS.project)
      }
      message.success(t('professor.message.loginSuccess'))
    } catch (e) {
      const error = e as ApiError
      message.error(error.statusMessage)
    }
  }
  return (
    <div className={styles.professorLoginPage} data-testid='professor-login-page'>
      <img
        className={styles.bg}
        src={commonUtils.getImagePath('pricingPage/pricing-page-bg.png')}
        alt=''
      />
      <div className={styles.content}>
        <img
          className={styles.logo}
          src={commonUtils.getImagePath('homePage/adeff-logo.png')}
          alt=''
        />
        <div className={styles.account}>
          <p className={styles.label}>{t('professor.account')}: </p>
          <AInput
            testId='professor-login-email-input'
            placeholder={t('professor.account')}
            onChange={(e) => {
              setEmail(e.target.value)
            }}
          />
        </div>
        <div className={styles.password}>
          <p className={styles.label}>{t('professor.password')}: </p>
          <APassword
            testId='professor-login-password-input'
            placeholder={t('professor.password')}
            onChange={(e) => {
              setPassword(e.target.value)
            }}
          />
        </div>
        <AButton testId='professor-login-submit-btn' type='primary' size='LG' className={styles.loginButton} onClick={handleLogin}>
          {t('professor.login')}
        </AButton>
      </div>
    </div>
  )
}

export default ProfessorLoginPage
